'use client';
import { ExploreDetails } from '@/app/elements/video/subcomponents/video-details-wrapper/explore-details/explore-details';
import { FavoritesButton } from '@/app/elements/favorites-button/favorites-button';
import type { SocialTagBadgeState } from '@/types/games';
import type { LauncherUrlProps } from '@/utils/url/launcher-url';

type VideoDetailsProps = {
    detailsLayout?: string;
    title?: string;
    info?: string;
    legal?: string;
    logo?: string;
    background?: string;
    uid: string;
    launcherUrlProps?: LauncherUrlProps;
    uniquePlayersCount?: number;
    socialTagBadgeState?: SocialTagBadgeState;
    showNotificationIcon?: boolean;
};

export const VideoDetailsWrapper = ({
    detailsLayout,
    title,
    info,
    legal,
    logo,
    background,
    uid,
    socialTagBadgeState,
    uniquePlayersCount,
    launcherUrlProps,
    showNotificationIcon = false
}: VideoDetailsProps) => {
    switch (detailsLayout) {
        case 'explore-header-container': {
            if (!title || !info || !logo || !background || !launcherUrlProps) {
                return null;
            }
            return (
                <ExploreDetails
                    title={title}
                    info={info}
                    logo={logo}
                    background={background}
                    uid={uid}
                    socialTagBadgeState={socialTagBadgeState}
                    uniquePlayersCount={uniquePlayersCount}
                    launcherUrlProps={launcherUrlProps}
                    showNotificationIcon={showNotificationIcon}
                />
            );
        }
        default: {
            return (
                <div className="video__details">
                    <div>
                        <p className="title">{title}</p>
                        <p className="info">{info}</p>
                        {legal && <p className="legal">{legal}</p>}
                    </div>
                    <FavoritesButton uid={uid} isRenderRequired />
                </div>
            );
        }
    }
};
